import { Platform } from 'react-native';
import { detectMobileWebOsFromUserAgent } from './detectMobileWebOsFromUserAgent.helper';

export type { MobileWebOs } from './detectMobileWebOsFromUserAgent.helper';
export { detectMobileWebOsFromUserAgent } from './detectMobileWebOsFromUserAgent.helper';

import type { MobileWebOs } from './detectMobileWebOsFromUserAgent.helper';

export function detectMobileWebOs(): MobileWebOs | null {
  if (Platform.OS !== 'web') return null;
  if (typeof navigator === 'undefined') return null;
  return detectMobileWebOsFromUserAgent(navigator.userAgent);
}
